import { createAction } from "redux-act";

export const CREATE_USER_ROLE = "CREATE_USER_ROLE_DATA";
export const CREATE_USER_ROLE_FAILED = "CREATE_USER_ROLE_FAILED";
export const CREATE_USER_ROLE_SUCCESS = "CREATE_USER_ROLE_SUCCESS";

export const createUserRole = createAction(CREATE_USER_ROLE);
export const createUserRoleFailed = createAction(CREATE_USER_ROLE_FAILED, (payload) => payload);
export const createUserRoleSuccess = createAction(CREATE_USER_ROLE_SUCCESS);
